import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import { useBoundStore } from '../../store/store'
import closeModal from '../../utils/closeModal'
import Modal from '../common/modal'
import Icon from '../icon'

const UnsuccessfulVerificationModal = () => {
  const verif_request_comment = useBoundStore(
    state => state.user.verif_request_comment,
  )
  const modal = useModal()
  const { t } = useTranslation('kyc')

  return (
    <Modal
      id="unsuccessful-verification-modal"
      containerStyle="w-[calc(100%-32px)] xl:max-w-[450px]">
      <h3 className="font-black text-xl text-txt flex items-center justify-center mb-6 xl:text-2xl">
        <Icon
          className="mr-2.5 xl:w-[35px] xl:h-[35px]"
          id="exclamation-circle"
          width="30"
          height="30"
        />
        {t('unsuccessful-verification')}
      </h3>
      <p className="font-normal text-[15px] text-txt text-center mb-6 xl:text-[17px]">
        {t('remarks')}: {verif_request_comment}
      </p>
      <Link to="/profile/kyc">
        <button
          className="text-center text-lg w-max bg-primary-btn-bg border-primary-btn-bg text-primary-btn-txt transition-all duration-[0.2s] ease-[ease-in-out] cursor-pointer font-normal block mx-auto my-0 px-9 py-[7px] rounded-[22px] border-[1.5px] border-solid xl:text-xl xl:w-[170px] xl:px-0 xl:py-2.5 xl:rounded-[26px]"
          onClick={() => closeModal(modal)}>
          {t('proceed')}
        </button>
      </Link>
    </Modal>
  )
}

export default NiceModal.create(UnsuccessfulVerificationModal)
